import { render, staticRenderFns } from "./alarmCFG.vue?vue&type=template&id=3fd051c7&scoped=true"
import script from "./alarmCFG.vue?vue&type=script&lang=js"
export * from "./alarmCFG.vue?vue&type=script&lang=js"
import style0 from "./alarmCFG.vue?vue&type=style&index=0&id=3fd051c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd051c7",
  null
  
)

export default component.exports